<template>
    <BaseDialog
        :showDialog="showDialog"
        :close="closeDialog"
        persistent
        headline="lang_GENERAL_ACTION_OPTION_UPDATE_ERROR_LIST"
        :alvqa="alvqa"
    >
        <template v-slot:dialogText>
            <v-container fluid> 
                <v-row>
                    <v-col 
                        class="text-center"
                        v-html="dialogText"
                        :alvqa="alvqa + '-text'"
                    ></v-col>
                </v-row> 
                <v-row>
                    <v-col>
                        <v-progress-linear 
                            v-model="progressbarValue"
                            height="25"
                            :alvqa="alvqa + '-progressbar'"
                            color="dialogProgressbar"
                        >{{ progressbarValue }} %</v-progress-linear>
                    </v-col>
                </v-row>
            </v-container>  
        </template>
    </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog'

export default {
    name: "RunErrorListDialog",
    props: {
        context: String
    },
    components: {
        BaseDialog
    },
    data() {
        return {
            alvqa: "dialog-run-error-list",
        }
    },
    computed: {
        showDialog: {
            get() { return this.$store.getters.getShowRunErrorListDialog },
            set(show) { this.$store.commit('setShowRunErrorListDialog', show) }
        },
        dialogText: {
            get() { return this.$store.getters.getRunErrorListDialogText },
            set(text) { this.$store.commit('setRunErrorListDialogText', text) }
        },
        progressbarValue: {
            get() { return this.$store.getters.getRunErrorListDialogProgressValue },
            set(value) { this.$store.commit('setRunErrorListDialogProgressValue', value) }
        }
    },
    methods: {
        closeDialog() {
            this.showDialog = false
            this.dialogText = ""
            this.progressbarValue = 0
            this.$store.commit("setRunErrorListDialogPolling", null)

            // Context related mutation
            this.$store.commit("setSelected" + this.context + "Action", [])
            this.$store.commit("setIsAllSelected" + this.context, false)
            this.$store.commit("setSelected" + this.context, [])
            this.$store.commit('setExpanded' + this.context, [])
        }
    }
}
</script>